<!-- SIDEBAR (respaldo, oculto: se reactiva con `useSidebarLayout = true` en sidenav.ts) -->
<!-- Menú lateral solo en pantallas muy anchas (xxl+); en laptop/tablet se usa el menú del topnav -->
@if (useSidebarLayout) {
<section id="sidebar" [ngClass]="status ? 'hide' : ''" class="ms-2 app-sidebar d-none d-xxl-block">
  <div (mouseenter)="handleMouseEnter()" (mouseleave)="handleMouseLeave()" class="sidebar">
    <ul class="side-menu mt-5">
      @for (item of sidebarItems; track item.id) {
      @if(hasAccess(item.allowedRoles)){
      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a [routerLink]="item.route">
          <fa-icon
            [icon]="item.icon"
            [class.support-menu-icon--unread]="isSupportMenuItem(item) && supportUnreadCount > 0"
            [attr.aria-label]="isSupportMenuItem(item) && supportUnreadCount > 0 ? ('SIDENAV.SUPPORT_UNREAD' | translate) : null">
          </fa-icon>
          <span class="text p-2 notranslate">{{ item.label | translate }}</span>
        </a>
      </li>
      }
      }
    </ul>
    <ul class="side-menu mb-5">
      <li>
        <a class="logout" (click)="logout()" style="cursor: pointer;">
          <fa-icon [icon]="['fas', 'right-from-bracket']"></fa-icon>
          <span class="text p-2 notranslate">{{ 'SIDENAV.SIGN_OUT' | translate }}</span>
        </a>
      </li>
    </ul>
  </div>
</section>
}
<!-- SIDEBAR -->

<!-- TOPNAV -->
<header class="app-topnav" role="banner" [class.app-topnav--support]="supportAccess">
  @if (supportAccess) {
  <div class="sp-support-banner">
    <div class="sp-support-banner__text">
      <i class="pi pi-shield" aria-hidden="true"></i>
      <span>{{ 'SIDENAV.SUPPORT_SESSION_BANNER' | translate }}</span>
    </div>
    <button
      type="button"
      class="sp-support-banner__exit"
      (click)="exitSupportChurch()"
      [disabled]="exitingSupport">
      @if (exitingSupport) {
      <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
      } @else {
      <i class="pi pi-sign-out" aria-hidden="true"></i>
      }
      {{ 'SIDENAV.EXIT_CHURCH' | translate }}
    </button>
  </div>
  }
  <div class="app-topnav__inner">
    <div class="app-topnav__brand">
      <div class="app-topnav__logo-wrap" aria-hidden="true">
        <img src="../../../assets/images/logo_mmm_navbar.png" alt="" class="app-topnav__logo" />
      </div>
      <div class="app-topnav__identity min-w-0">
        @if(accessibleChurches.length > 1) {
        <div class="dropdown">
          <button type="button" class="app-topnav__church-btn dropdown-toggle notranslate" id="churchDropdown"
            data-bs-toggle="dropdown" aria-expanded="false">
            <span class="app-topnav__church-name text-truncate">{{ churchName || 'MMM España' }}</span>
            <i class="pi pi-chevron-down app-topnav__church-chevron" aria-hidden="true"></i>
          </button>
          <ul class="dropdown-menu app-topnav__dropdown shadow-lg border-0 animate__animated animate__fadeIn"
            aria-labelledby="churchDropdown">
            @for(church of accessibleChurches; track church.id) {
            <li>
              <button type="button" class="dropdown-item app-topnav__dropdown-item d-flex align-items-center justify-content-between"
                (click)="switchChurch(church.id)">
                <span class="notranslate">{{ church.name }}</span>
                @if(church.id === churchId) {
                <i class="pi pi-check app-topnav__check" aria-hidden="true"></i>
                }
              </button>
            </li>
            }
          </ul>
        </div>
        } @else {
        <span class="app-topnav__church-name notranslate text-truncate">{{ churchName || 'MMM España' }}</span>
        }
        <span class="app-topnav__eyebrow">{{ 'LAYOUT.ADMIN_PANEL_SUBTITLE' | translate }}</span>
      </div>
    </div>

    @if (!useSidebarLayout) {
    <nav class="app-topnav__nav d-none d-xl-flex" [attr.aria-label]="'SIDENAV.MAIN_NAV' | translate">
      <ul class="app-topnav__nav-list">
        @for (group of navGroups; track group.id) {
        @if (group.items.length === 1) {
        <li class="app-topnav__nav-item">
          <a class="app-topnav__nav-link" [routerLink]="group.items[0].route"
            [class.is-active]="isNavGroupActive(group)"
            [attr.aria-current]="isNavGroupActive(group) ? 'page' : null">
            <i [class]="group.primeIcon" aria-hidden="true"></i>
            <span class="notranslate">{{ (group.id === 'home' ? group.labelKey : group.items[0].labelKey) | translate }}</span>
            @if (groupHasSupportUnread(group)) {
            <span class="app-topnav__nav-dot" [attr.aria-label]="'SIDENAV.SUPPORT_UNREAD' | translate" role="status"></span>
            }
          </a>
        </li>
        } @else {
        <li class="app-topnav__nav-item dropdown">
          <button type="button" class="app-topnav__nav-link app-topnav__nav-link--toggle"
            data-bs-toggle="dropdown" data-bs-offset="0,10" aria-expanded="false" aria-haspopup="true"
            [class.is-active]="isNavGroupActive(group)">
            <i [class]="group.primeIcon" aria-hidden="true"></i>
            <span class="notranslate">{{ group.labelKey | translate }}</span>
            @if (groupHasSupportUnread(group)) {
            <span class="app-topnav__nav-dot" [attr.aria-label]="'SIDENAV.SUPPORT_UNREAD' | translate" role="status"></span>
            }
            <i class="pi pi-chevron-down app-topnav__nav-chevron" aria-hidden="true"></i>
          </button>
          <div class="dropdown-menu app-topnav__mega shadow-lg border-0">
            <span class="app-topnav__mega-title notranslate">{{ group.labelKey | translate }}</span>
            <ul class="app-topnav__mega-list">
              @for (item of group.items; track item.id) {
              <li>
                <a class="dropdown-item app-topnav__mega-item" [routerLink]="item.route"
                  [class.is-active]="isNavItemActive(item.route)"
                  [attr.aria-current]="isNavItemActive(item.route) ? 'page' : null">
                  <span class="app-topnav__mega-icon" aria-hidden="true"><i [class]="item.primeIcon"></i></span>
                  <span class="app-topnav__mega-text">
                    <span class="app-topnav__mega-label notranslate">{{ item.labelKey | translate }}</span>
                    <span class="app-topnav__mega-desc">{{ item.descriptionKey | translate }}</span>
                  </span>
                  @if (item.id === 'support' && supportUnreadCount > 0) {
                  <span class="app-topnav__mega-badge" [attr.aria-label]="'SIDENAV.SUPPORT_UNREAD' | translate">{{ supportUnreadCount }}</span>
                  }
                </a>
              </li>
              }
            </ul>
          </div>
        </li>
        }
        }
      </ul>
    </nav>
    }

    <div class="app-topnav__actions">
      <div class="app-topnav__lang">
        <app-language-selector></app-language-selector>
      </div>

      <div class="dropdown d-none d-md-block">
        <button type="button" class="app-topnav__user-pill" id="userMenuDropdown" data-bs-toggle="dropdown"
          data-bs-offset="0,10" aria-expanded="false" aria-haspopup="true">
          <span class="app-topnav__user-name">{{ displayName }}</span>
          <span class="app-topnav__avatar" aria-hidden="true">
            @if(photoURL){
            <img [src]="photoURL" (error)="photoURL = ''" alt="" class="app-topnav__avatar-img" />
            } @else {
            <img src="assets/images/default-avatar.png" alt="" class="app-topnav__avatar-img" />
            }
          </span>
          <i class="pi pi-chevron-down app-topnav__nav-chevron d-none d-xl-inline" aria-hidden="true"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end app-topnav__dropdown shadow-lg border-0"
          aria-labelledby="userMenuDropdown">
          @for (item of profileMenu; track $index) {
          <li>
            <button type="button" class="dropdown-item app-topnav__dropdown-item d-flex align-items-center"
              [class.text-danger]="item.label === 'SIDENAV.SIGN_OUT'"
              (click)="item.command ? item.command({}) : null">
              <i [class]="item.icon + ' app-topnav__menu-icon'" aria-hidden="true"></i>
              <span class="notranslate">{{ item.label | translate }}</span>
            </button>
          </li>
          }
        </ul>
      </div>

      <div class="app-topnav__avatar app-topnav__avatar--solo d-md-none" aria-hidden="true">
        @if(photoURL){
        <img [src]="photoURL" (error)="photoURL = ''" alt="" class="app-topnav__avatar-img" />
        } @else {
        <img src="assets/images/default-avatar.png" alt="" class="app-topnav__avatar-img" />
        }
      </div>

      <div class="dropdown" [class.d-xl-none]="!useSidebarLayout">
        <button type="button" class="app-topnav__menu-btn" id="appMenuDropdown" data-bs-toggle="dropdown"
          aria-expanded="false" aria-haspopup="true" [attr.aria-label]="'SIDENAV.OPEN_MENU' | translate">
          <i class="pi pi-bars" aria-hidden="true"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end app-topnav__dropdown app-topnav__dropdown--menu shadow-lg border-0 mt-2 animate__animated animate__fadeIn"
          aria-labelledby="appMenuDropdown">
          @for(item of profileMenuMobile; track $index) {
          @if(item.separator) {
          <li><hr class="dropdown-divider app-topnav__divider"></li>
          } @else {
          <li>
            <button type="button" class="dropdown-item app-topnav__dropdown-item d-flex align-items-center"
              (click)="item.command ? item.command({}) : null">
              <i
                [class]="item.icon + ' app-topnav__menu-icon'"
                [class.support-menu-icon--unread]="isSupportMenuItem(item) && supportUnreadCount > 0"
                [attr.aria-label]="isSupportMenuItem(item) && supportUnreadCount > 0 ? ('SIDENAV.SUPPORT_UNREAD' | translate) : null"
                aria-hidden="true"></i>
              <span class="notranslate">{{ item.label | translate }}</span>
            </button>
          </li>
          }
          }
        </ul>
      </div>
    </div>
  </div>
</header>
<!-- TOPNAV -->
<!-- CONTENT -->
<section id="content">
  <!-- MAIN -->
  <main>
    <router-outlet></router-outlet>
  </main>
  <!-- MAIN -->
</section>
<!-- CONTENT -->
<app-help-center />

